import http from '@/utils/http';

/**
 * 放款银行
 */
export default {
  getList: {
    p: 'post,/manage/bank/getlist',
    r: (data) => http({ url: '/manage/bank/getlist', method: 'post', data })
  },
  add: {
    p: 'post,/manage/bank/add',
    r: (data) => http({ url: '/manage/bank/add', method: 'post', data })
  },
  update: {
    p: 'post,/manage/bank/update',
    r: (data) => http({ url: '/manage/bank/update', method: 'post', data })
  },
  del: {
    p: 'post,/manage/bank/delete',
    r: (data) => http({ url: '/manage/bank/delete', method: 'post', data })
  },
  getOne: {
    p: 'post,/manage/bank/getone',
    r: (data) => http({ url: '/manage/bank/getone', method: 'post', data })
  },
  exportFile: {
    p: 'post,/system/export/user',
    r: (data) => http({ url: '/system/export/user', method: 'post', responseType: 'blob', data })
  }
};
